import { useState, useEffect } from 'react'
// import { useNavigate } from "react-router-dom";
import ApiClient from '../../../api/client'
// import Logo from '../../../../assets/logo.png'
// import { toast } from 'react-toastify'
import SideBar from '../SideBar'
import RightSideBar from '../RightSideBar'
// import { Link } from "react-router-dom";

import { Home, Users, FileText, Plus, Edit, Trash2 } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import Navbar from '../Navbar'
import SearchBar from '../SearchBar'
import { useUIStore } from '../../../../store/useUIStore'
import DeleteModal from './DeleteModal'
import UpdateProgramModal from './UpdateProgramModal'
import AddNewProgramModal from './AddNewProgramModal'
import { useSearchStore } from '../../../../store/useSearchStore'
import Chats from '../../../dashboard/assets/chats.png'
import { useProgramStore } from '../../../../store/useProgramStore'

const apiClient = new ApiClient()

const Programs = () => {
  const {
    deleteProgram,
    showDeleteModal,
    showUpdateModal,
    programToDelete,
    openDeleteModal,
    openUpdateModal,
    closeUpdateModal,
    fetchAllPrograms,
    closeDeleteModal,
    showAddProgramModal,
    openAddProgramModal,
    closeAddProgramModal,
  } = useProgramStore()

  const { filteredPrograms, searchQuery, setPrograms } = useSearchStore()

  const { isMobile, activeMenu } = useUIStore()
  const [error, setError] = useState('')
  const [programCat, setProgramCat] = useState({ status: '' })

  // Declare the ApiClient class for use and get its individual api functions
  const navigate = useNavigate()

  // Fetch clients data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data, error } = await apiClient.fetchAllPrograms()
        if (data) {
          setPrograms(data)
        } else {
          setError(error || 'Failed to fetch programs!')
        }
      } catch (err) {
        setError('Failed to fetch programs!')
      }
    }

    fetchData()
  }, [showDeleteModal, showUpdateModal, showAddProgramModal])

  const handleClientImageClick = (clientId) => {
    navigate(`/dashboard/client/${clientId}/family`)
  }

  // Delete a particular client
  const handleDeleteProgram = async () => {
    if (programToDelete) {
      await deleteProgram(programToDelete.id)
      closeDeleteModal()
      // toast.success(`${programToDelete?.name} has been deleted successfully!`, {
      //   position: 'top-right',
      //   autoClose: 3000,
      //   theme: 'colored',
      // })
    }
  }
  // const statusOptions = ['RBI', 'CBI']

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target
  //   setProgramCat((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }))

  // Clear error when user starts typing
  // if (errors[name]) {
  //   setErrors((prev) => ({
  //     ...prev,
  //     [name]: '',
  //   }))
  // }
  // }

  return (
    <>
      <div className="flex h-screen bg-gray-100">
        {/* Mobile Overlay */}
        {/* {isMobile && !isCollapsed && (
          <div 
            className="fixed inset-0 z-40 md:hidden"
            // onClick={toggleSidebar}
          />
        )} */}
        <SideBar />
        {/* Main Content */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* Header Bar */}
          <Navbar />

          {/* Main Content Area */}
          <main className="flex-1 w-full p-6 bg-gray-100 overflow-auto">
            {isMobile && (
              <div className="mb-4">
                <SearchBar />
              </div>
            )}
            <div className="w-full mb-4">
              <h1 className="text-2xl md:text-4xl font-bold text-gray-900">
                Program Dashboard
              </h1>
            </div>

            <div className="flex overflow-auto">
              {/* Program section */}
              <div className="w-full bg-[#E8ECFF] p-8 h-full rounded-md overflow-x-auto bg-[#E8ECFF] pb-4 rounded-md">
                {activeMenu === 'Programs' ? (
                  // Dashboard/Home Content
                  <div className="mx-auto">
                    {/* Header Section */}
                    <div className="mb-6">
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                        <div className="flex flex-col md:flex-row gap-3">
                          {/* Add New Client Button */}
                          <button
                            onClick={openAddProgramModal}
                            className="flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200"
                          >
                            <Plus className="w-4 h-4" />
                            <span>Add New Program</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Client Table */}
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden mb-10">
                      {/* {error && (
                      <div className="p-4 bg-red-50 border-l-4 border-red-400">
                        <p className="text-red-700">{error}</p>
                      </div>
                    )} */}

                      {/* Table Header */}
                      <div
                        className={`bg-white px-6 py-4 border-b border-gray-200 ${isMobile ? 'mx-auto' : 'w-full'}`}
                      >
                        <div
                          className={`${isMobile ? 'grid justify-between text-sm font-bold text-[24]' : 'flex justify-between text-sm font-bold text-[24]'}`}
                        >
                          <div className="text-[24px]">Programs</div>
                          {/* <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1 ">
                              Program Category
                            </label>
                            <select
                              name="status"
                              value={programCat.status}
                              onChange={handleInputChange}
                              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#3d6be0] focus:border-transparent"
                            >
                              {statusOptions.map((status) => (
                                <option key={status} value={status}>
                                  {status}
                                </option>
                              ))}
                            </select>
                          </div> */}
                        </div>
                      </div>
                      <div className="w-auto h-1 bg-[#E8ECFF] w-full"></div>
                      {/* Program thumbnails */}
                      <div className="flex gap-4 p-8 overflow-x-auto overflow-hidden">
                        {filteredPrograms.length > 0 ? (
                          filteredPrograms.map((program) => (
                            <div key={program.id} className="relative group">
                              <div className="flex justify-center bg-white border border-ray-300  text-sm md:text-lg overflow-auto text-wrap w-[150px] h-[170px] md:w-[260px] md:h-[275px]">
                                {/* update and delete icons */}
                                {/* <div>
                                    <form onSubmit={handleSubmit}>
                                      <div>
                                        <input type="text" />
                                      </div>
                                    </form>
                                  </div> */}

                                <div className="  grid justify-center items-center w-auto">
                                  <div className="mx-2 my-2 md:y-4">
                                    <img
                                      src={program.image}
                                      alt="program_image"
                                      className=" min-w-[130px] h-[120px] md:w-[230px] md:h-[200px]"
                                    />
                                  </div>
                                  <div className="text-center mb-2 md:mb-4">
                                    <div>
                                      {program.name.toUpperCase()}{' '}
                                      {/* <span>({program.program_code.toUpperCase()})</span> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* Update button */}

                              <button
                                onClick={() => openUpdateModal(program)}
                                className="absolute top-2 left-2 opacity-0 group-hover:opacity-100 transition-opacity text-blue-300 p-1 bg-gray-800 rounded-full w-6 h-6 flex items-center justify-center text-sm hover:bg-gray-600"
                              >
                                <Edit />
                              </button>
                              {/* Delete button */}
                              <button
                                onClick={() => openDeleteModal(program)}
                                className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm hover:bg-red-600"
                              >
                                ×
                              </button>
                            </div>
                          ))
                        ) : (
                          <div className="px-6 py-12 text-center">
                            <Users className="w-12 h-12 text-gray-300 mx-auto mb-4" />
                            <p className="text-gray-500">
                              {searchQuery
                                ? 'No program found matching your search.'
                                : 'No programs found.'}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="overflow-x-auto bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden ">
                      <div className="grid items-center text-sm font-bold text-[24] px-6 py-4 border-b border-gray-200">
                        <div className="text-[24px] z-10">Client Analytics</div>
                        <div className="flex justify-center items-center md:p-20 p-4 h-[350px] ">
                          {/* <span>The program graph appears here</span> */}
                          <img
                            src={Chats}
                            alt=""
                            className="min-w-[290px] min-h-[160px]"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  // Other Menu Content
                  <div className="max-w-4xl mx-auto">
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                      <h3 className="text-lg font-medium text-gray-900 mb-4">
                        Welcome to {activeMenu}
                      </h3>
                      <p className="text-gray-600 mb-4">
                        You are currently viewing the {activeMenu} section. The
                        sidebar automatically collapses on medium screens and
                        below, showing only icons with helpful tooltips on
                        hover. Click on different menu items to see them become
                        active.
                      </p>

                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
                        <div className="bg-blue-50 p-4 rounded-lg">
                          <div className="flex items-center">
                            <Home className="w-8 h-8 text-blue-600" />
                            <div className="ml-3">
                              <p className="text-sm font-medium text-blue-600">
                                Dashboard
                              </p>
                              <p className="text-xs text-blue-500">
                                Main overview
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="bg-green-50 p-4 rounded-lg">
                          <div className="flex items-center">
                            <Users className="w-8 h-8 text-green-600" />
                            <div className="ml-3">
                              <p className="text-sm font-medium text-green-600">
                                Clients
                              </p>
                              <p className="text-xs text-green-500">
                                Manage clients
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="bg-purple-50 p-4 rounded-lg">
                          <div className="flex items-center">
                            <FileText className="w-8 h-8 text-purple-600" />
                            <div className="ml-3">
                              <p className="text-sm font-medium text-purple-600">
                                Documents
                              </p>
                              <p className="text-xs text-purple-500">
                                File management
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="hidden lg:flex invisible lg:visible">
                <RightSideBar />
              </div>
            </div>
          </main>
        </div>
      </div>

      {/* Reusable DeleteModal */}
      <DeleteModal
        isOpen={showDeleteModal}
        title="Confirm Delete"
        message={`Are you sure you want to delete "${programToDelete?.name}"?`}
        onConfirm={handleDeleteProgram}
        onCancel={closeDeleteModal}
      />

      {/* Reusable UpdateProgramModal */}
      <UpdateProgramModal />

      {/* Reusable AddNewProgramModal */}
      <AddNewProgramModal
        isOpen={showAddProgramModal}
        onClose={closeAddProgramModal}
      />
    </>
  )
}

export default Programs
